import { render, staticRenderFns } from "./NDCFareOption.vue?vue&type=template&id=5576bdca&scoped=true&"
import script from "./NDCFareOption.vue?vue&type=script&lang=js&"
export * from "./NDCFareOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576bdca",
  null
  
)

export default component.exports